module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAS1BMVEX3tgD4tgD3tQD////+/Pb4xz398dD867z5yUT4xTj3uRD3tgP++Oj989n98tT97cP85KT724T613j60mP50F75zlf5ykr4wSz4wCdoYTcPAAAAAnRSTlPjSQzAlCMAAACMSURBVCjPfdJLDsMgDEVRamMIkP9//ystVeMoRiZ3EEXvCIkB5mNAKc8G1MQuegJRBbzXgRBJBY/oNQiYCwXEsE79D/ppDfGGo0VRe/CJxj532wADC+8MObrFkrzVwrCAhJlhLmBkGAtweRuG/HESkkW3A+wObRJwdtv/Z+tOATHBVYoCZO9QEVN9Pl8QbwcjeEGzQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/star.png
// module id = kE3i
// module chunks = 0